import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const ORDER_MENU: PermissionTableRowType = {
  name: '주문',
  key: 'ORDER_MANAGE',
  subRows: [
    {
      name: '주문 관리',
      key: PERMISSION_SUBJECTS.ORDER,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.UPDATE,
        PERMISSION_ACTIONS.DOWNLOAD_EXCEL,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.ORDER,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '주문 상세 조회',
          key: PERMISSION_SUBJECTS.ORDER,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '주문 상태 변경',
          key: PERMISSION_SUBJECTS.ORDER,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
        {
          name: '주문 엑셀 다운로드',
          key: PERMISSION_SUBJECTS.ORDER,
          permissions: [PERMISSION_ACTIONS.DOWNLOAD_EXCEL],
        },
      ],
    },
    {
      name: '반품 관리',
      key: PERMISSION_SUBJECTS.ORDER_RETURN,
      permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
      subRows: [
        {
          name: '반품 상세 조회',
          key: PERMISSION_SUBJECTS.ORDER_RETURN,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '반품 완료 처리',
          key: PERMISSION_SUBJECTS.ORDER_RETURN,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
  ],
};
